var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _path, _circle19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 13.2,
    cy: 5,
    r: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 18.6,
    cy: 5,
    r: 1.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 23.9,
    cy: 5,
    r: 1.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 29.3,
    cy: 5,
    r: 1.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 13.2,
    cy: 37.5,
    r: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 18.6,
    cy: 37.5,
    r: 1.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 23.9,
    cy: 37.5,
    r: 1.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 29.3,
    cy: 37.5,
    r: 1.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 8,
    cy: 31.9,
    r: 1.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 8,
    cy: 26.6,
    r: 1.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 8,
    cy: 21.2,
    r: 1.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 8,
    cy: 15.9,
    r: 1.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 8,
    cy: 10.6,
    r: 1.4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 34.5,
    cy: 31.9,
    r: 1.4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 34.5,
    cy: 26.6,
    r: 1.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 34.5,
    cy: 21.2,
    r: 1.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 34.5,
    cy: 15.9,
    r: 1.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dark_dot",
    cx: 34.5,
    cy: 10.6,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.8 23.4h14.6M13.8 29.7h14.6"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.8,
    cy: 12.7,
    r: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDraft);
export default __webpack_public_path__ + "static/media/documentDraft.7d7c5440559c92847bfb9f69d760152b.svg";
export { ForwardRef as ReactComponent };